import { format, formatRegionalDate } from '@spx-portal/shared-utils';

import { $gt } from '@/common/appCtx';

const operationColumn = {
  get title() { return $gt('Operation'); },
  dataIndex: 'operation',
  key: 'operation',
  width:200,
};

const operatorColumn = {
  get title() { return $gt('Operator'); },
  dataIndex: 'operator',
  key: 'operator',
  width:200,
};

const updateTimeColumn = {
  get title() { return $gt('Update Time'); },
  dataIndex: 'update_time',
  key: 'update_time',
  width:200,
  render: (val: number) => {
    return formatRegionalDate(val);
  },
};

const affectedWorkstationIDColumn = {
  get title() { return $gt('Affected Workstation ID'); },
  dataIndex: 'biz_workstation_id_list_str',
  key: 'biz_workstation_id_list_str',
  width:200,
};

export const useFields = () => {
  const tableColumns = [
    operationColumn,
    operatorColumn,
    updateTimeColumn,
    affectedWorkstationIDColumn,
  ];

  return {
    tableColumns,
  };
};
